export default __webpack_public_path__ + "static/media/hop5.12b09124.jpg";